<template>
  <div class="social-list">
    <p class="header">Get Connected</p>
    <ul class="stack-vertical">
      <li class="stack-vertical__item" v-for="item in itemList">
        <span class="socicon--single socicon-{{item.service}}"></span>
        <a v-bind:href="item.url" class="text-link">{{item.displayString || item.url}}</a>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      itemList: {
        type: Object,
      },
    },
  };
</script>

<style lang="scss">
</style>


/** WEBPACK FOOTER **
 ** SocialList.vue?444e1506
 **/